import React, { useState } from "react";
import axios from "axios";

const StoreDetails = ({ closeModal, store }) => {
  //   const [showModal, setShowModal] = useState(false);
  console.log(store);
  return (
    <>
      <div className=" flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full h-full max-w-md md:h-auto">
          <div className="relative bg-white rounded-lg shadow ">
            <section className="bg-white">
              <div className="max-w-2xl px-4 py-8 mx-auto lg:py-10">
                <div className="flex justify-between">
                  <h2 className="mb-4 text-xl font-bold text-gray-900">
                    Add product
                  </h2>
                  <button
                    type="button"
                    className=" text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    onClick={closeModal}
                  >
                    <svg
                      aria-hidden="true"
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <span className="sr-only">Close modal</span>
                  </button>
                </div>
                <div className="flex flex-col justify-start p-6">
                  <h5 className="mb-2 text-3xl font-bold text-neutral-800">
                    {store.name}
                  </h5>
                  <p className="mb-4 text-base text-neutral-600 ">
                    {store.address}
                  </p>

                  <span className="text-2xl font-semibold inline-block text-teal-500">
                    Cost {store.cost}
                  </span>
                  <span className="text-2xl font-semibold inline-block text-teal-500">
                    Sell {store.sell}
                  </span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreDetails;
